// project import
import grocery from './grocery';
import management from './management';
import utility from './utility'

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [grocery, utility, management ]
};

export default menuItems;
